import React from 'react';
import { HookFormAutocomplete } from '../../common/components';
import { CircularProgress } from '@mui/material';
import { useSubscription } from '@apollo/client';
import { GET_DOCUMENTS_QUERY } from '../../clinics/gql/Query';
import { capitalize } from 'lodash';

export default function DocumentOptions({ prefix, control, errors, schema, placeholder, label, skip='' }) {
    const { loading, data } = useSubscription(GET_DOCUMENTS_QUERY, { variables: { limit: 100 } });
  
    if (loading) return <CircularProgress />;
  
    return (
      <HookFormAutocomplete
        id={schema}
        name={schema}
        placeholder={placeholder}
        label={label}
        schema={schema}
        prefix={prefix}
        control={control}
        errors={errors}
        autocompleteProps={{
          includeInputInList: true,
          multiple: true,
          freeSolo: true,
          fullWidth: true,
        }}
        options={
          data && data.hasOwnProperty('rows')
            ? data.rows.filter(i => { return i.name !== skip}).map(i => ({ value: i.name, label: capitalize(i.name) }))
            : []
        }
        getOptionLabel={option => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.label;
        }}
        renderOption={(props, option) => (
          <li key={option.value} {...props}>
            {capitalize(option.label)}
          </li>
        )}
      />
    );
  }